import axios from "axios";
import "./Weather.css";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import { useState } from "react";

export default function Weather (props) {
    const [weatherData, setWeatherData] = useState({ ready: false});
    const [city, setCity] = useState(props.defaultCity);
    function handleResponse(response){
    setWeatherData({
        ready: true,
        coordinates: response.data.coordinates,
        city: response.data.city,
        temperature: Math.round(response.data.temperature.current),
        wind: response.data.wind.speed,
        humidity: response.data.temperature.humidity,
        description: response.data.condition.description,
        icon: response.data.condition.icon,
        date: new Date (response.data.time * 1000),
    })
    }
    function search () {
        const apiKey = "141903t193o7f25eb4f8b827eac040ff";
        let apiUrl =`https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
        axios.get(apiUrl).then(handleResponse);
    }

    function handleSubmit (event) {
        event.preventDefault();
        search();
    }

    function handleCityChange (event) {
        setCity(event.target.value);
    }

    if (weatherData.ready) {
        return <div className="Weather">
    <form onSubmit={handleSubmit}>
        <div className="row">
        <div className="col-9">
        <input type="search" placeholder="Enter a City..." className="form-control" autoFocus="on"
        onChange={handleCityChange}/>
        </div>
        <div className="col-3">
        <input type="submit" value="Search" className="btn btn-primary w-100"/>
        </div>
        </div>
    </form>
    <WeatherInfo data={weatherData}/>
    <WeatherForecast coordinates={weatherData.coordinates}/>
 </div>
} else {
    search();
    return "Loading...";
}
}
